<template>
  <not-found-card />
</template>

<script>
/**
 * This is the view for 404 page
 * This will be rendered when user hits any orphan url
 */
import NotFoundCard from '@/components/NotFoundCard'

export default {
  name: 'PageNotFound',
  components: {
    NotFoundCard
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_base.scss';
</style>
